import React from 'react';
import clsx from 'clsx';
import { Box, CircularProgress } from '@mui/material';
import { Column } from '../types';
import { getStickySx } from '../libs';
import { TableCell } from './TableCell';
import { mergeCellStyles } from './mergeCellStyles';

interface Props<Data extends Record<string, any>, Context extends any = any> {
  context: Context;
  loading: boolean;
  tableData: Data[];
  columns: Column<Data, Context>[];
}

export const TableBody = <Data extends Record<string, any>, Context extends any = any>({
  columns,
  loading,
  context,
  tableData,
}: Props<Data, Context>) => {
  if (loading)
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '10rem' }}>
        <CircularProgress />
      </Box>
    );

  return (
    <Box>
      {tableData.map((row, rowIndex) => (
        <Box key={row?.id ?? `row_${rowIndex}`} className={clsx('listing-section', 'listing-body')}>
          {columns.map((column, columnIndex) => (
            <TableCell
              key={`${column.renderKey.toString()}_${rowIndex}_${columnIndex}`}
              column={column}
              context={context}
              sx={{
                ...getStickySx(column, columns, columnIndex),
                ...mergeCellStyles(column?.cellStyles, column?.bodyStyles),
              }}
            >
              {column.renderCell
                ? // @ts-expect-error Just pass it
                  column.renderCell({
                    row,
                    column,
                    columns,
                    context,
                    rowIndex,
                    columnIndex,
                    value: row[column.renderKey] || row,
                    existingColumnsTypes: columns.map(({ columnType }) => columnType).filter(Boolean) as string[],
                  })
                : column?.formatter
                  ? column.formatter(row[column.renderKey])
                  : row[column.renderKey]}
            </TableCell>
          ))}
        </Box>
      ))}
    </Box>
  );
};
